export default {
    groupName: 'pfizer',
    appName: 'Pfizer',
    baseRoute: '/dashboard/pfizer',
    label: 'Pfizer Ad Effect Dashboard',
    home: '/slicer',
    image: 'pfizer.png',
    description: 'Pfizer Ad Effect Tracker Dashboard'
};


// WEBPACK FOOTER //
// ./src/app/configuration/Pfizer/config/main.js